<template>
<!-- 分享 返回 首页 -->
    <div class="Sharehomepage" >
           <div class="share">
               <div class="share-own" @click="open()">
                 <div class="imgsa">
                 <img style="width: 14px;
                 height: 15px;"
                   src="../../assets/share1.png" alt="">
                 </div>
                <span>分享</span>
               </div>
                <div class="share-own" style="margin-top:19px ;" @click="Jumppage()">
                <div class="imgsa">
                <img style="width: 15px;
                height: 16px;"
                src="../../assets/Homepage.png" alt="">
                </div>
                <span>首页</span>
               </div>
          </div>
    </div>
</template>
<script>
export default {
  methods: {
    open () {
      this.$alert('www.幕课.com', '复制并分享', {
        // confirmButtonText: '确定',
      //   callback: action => {
      //   //   this.$message({
      //   //     type: 'info',
      //   //     message: `action: ${action}`
      //   //   })
      //   // }
      }
      )
    },
    Jumppage () {
      this.$router.push('/')
    }
  }
}
</script>
<style scoped  lang='scss'>

   .share{
      // margin-top:100% ;
      .share-own{
        width: 42px;
        cursor:pointer;
        .imgsa{
          width: 42px;
          height: 42px;
          line-height: 42px;
          text-align: center;
            img{
            background: #F8F8F8;
            border-radius: 50%;
          }
        }
        span{
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        }
      }

    }
</style>
